import React from 'react';
import Sheet from "@mui/joy/Sheet";
import Button from "@mui/joy/Button";
import {Box} from "@mui/joy";


const Navbar = () => {
    return (
        <>
            <Sheet sx={{
                p: 2,
                gap: 2,
                bgcolor: 'rgba(246, 247, 248, 0.9)',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                gridColumn: '1 / -1',
                borderBottom: '1px solid rgb(10 17 41/5%)',
                position: 'sticky',
                backdropFilter: 'blur(10px)',
                top: 0,
                zIndex: 20,
            }} variant="outline">
                <Box sx={{ flex: '0.5', display: 'flex', justifyContent: 'center' }}>
                    <img src="/logo.svg" alt="logo" style={{ width: '152px' }} />
                </Box>
                <Box sx={{ flex: '0.5', display: 'flex', justifyContent: 'center' }}>
                    <Button color="primary" variant="plain">Рус</Button>
                </Box>
            </Sheet>
        </>
    );
}

export default Navbar;